import gql from 'graphql-tag';

export default gql`
  query fetchHowToAllegiantSection {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        howToAllegiant {
          title
          description
          clickThrough {
            url
            title
            target
          }
          items {
            title
            image
          }
        }
      }
    }
  }
`;
